import AppConfig from '../../config/AppConfig';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getBranchId, getJwtToken } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaContractTypes } from './sagaContractRedux';
import { push } from 'react-router-redux';
import { buildUrl, getSagaWAPUrl } from '../../helpers/utility';
import { currentLanguageRfc3066Fnc } from '../languageSwitcher/languageSwitcherSaga';
import { Result } from '../../redux/helpers/Ihelper';
import IContractDetailUpdate from '../../redux/sagaContract/IContractDetailUpdate';

export const getContractHistoryFnc = (state) => state.SagaContract.contractHistory;

export function* requestContractDetail(action) {
    const tag = '[REQUEST_CONTRACT_DETAIL]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const contractid = action.contractId;
        if (jwtToken || branchId || culture) {
            // step 2 : validation passed..
            const response = yield call(API.requestContractDetail, jwtToken, branchId, culture, action.contractInput);
            if (response.status === 200 && response.data.statusCode === 200) {

                console.log(`${tag} requestContractDetail response :`, response.data, action.contractId);
                if (contractid === 0) {
                    yield put(push(buildUrl(`/dashboard/contract/?iframe=true&offerId=${action.offerId}&contractId=${response.data.result.contract.contractId}`)));
                } else {
                    yield put(Actions.contractDetailSuccess(response.data.result));
                    return response.data.result;
                }
            } else {
                console.warn(`${tag} requestContractDetail invalid response :`, response);
                throw new Error(JSON.stringify(response.data.error));
            }

        } else {
            throw new Error('project.NotLoggedIn'); // <-- fix me
        }


    }
    catch (e) {
        console.warn(`${tag} requestContractDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.contractDetailFailure(message));
    }
}

export function* requestUpdateContractDetail(action) {
    const tag = '[REQUEST_UPDATE_CONTRACT_DETAIL]';
    try {
        // step 1: perform input validation
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const result = validateRequestUpdateContractDetail(action.contractDetail);
        if (jwtToken || branchId || culture) {

            if (result.isValid) {
                // step 2 : validation passed..
                const response = yield call(API.UpdateContractDetail, jwtToken, action.contractDetail, branchId);
                if (response.status === 200 && response.data.statusCode === 200) {
                    console.log(`${tag} requestUpdateContractDetail response :`, response.data);
                    yield put(Actions.updateContractDetailSuccess(response.data.result.result));
                    if (action.isRedirectToDeed === true) {
                        yield put(push(buildUrl(`/dashboard/deedDetail/?iframe=true&offerId=${action.offerId}&contractId=${response.data.result.contractId}&deedId=${action.deedId}&activeTab=1`)));
                    } else {
                        // window.top.location.href = getSagaWAPUrl('contract',  'user', 'password', branchId, { offerId: action.offerId, contractId: response.data.result.contractId,activeTab:1  });
                        yield put(push(buildUrl(`/dashboard/contract/?iframe=true&offerId=${action.offerId}&contractId=${response.data.result.contractId}&activeTab=1&propertyId=${action.contractDetail.propertyId}`)));
                    }
                } else {
                    console.warn(`${tag} requestUpdateContractDetail invalid response :`, response);
                    throw new Error(response.data.error);
                }
            } else {

                yield put(Actions.updateContractDetailFailure(result.errorMessages));
            }

        } else {
            throw new Error('project.NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateContractDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateContractDetailFailure(message));
    }
}

function validateRequestUpdateContractDetail(contractDetail: IContractDetailUpdate) {
    const result: Result = {
        isValid: false,
        errorMessages: []
    };
    if (!contractDetail) {
        result.isValid = true;
        return result;
    }
    let isValid = true;
    const errorMessage: string[] = [];

    // contractName name
    if (contractDetail.contractInfomations.name.length === 0) {
        errorMessage.push('error.contractDetail.name');
        isValid = false;
    }

    result.isValid = isValid;
    result.errorMessages = errorMessage;
    return result;
}

export function* requestupdateContractPaymentBreakdown(action) {
    const tag = '[REQUESTUPDATE_CONTRACT_PAYMENT_BREAKDOWN]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        const inputValid = false; // IDE-Help, do not delete me
        if (jwtToken || branchId || culture) {
            // step 2 : validation passed..
            const response = yield call(API.UpdateContractPaymentBreakdown, jwtToken, action.paymentBreakDowns, action.offerId, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestupdateContractPaymentBreakdown response :`, response.data);
                yield put(Actions.updateContractPaymentBreakdownSuccess(response.data.result));
                // window.top.location.href = getSagaWAPUrl('contract',  'user', 'password', branchId, { offerId: action.offerId, contractId: action.contractId,activeTab: 2  });
                // yield put(push(buildUrl(`/dashboard/contract/?iframe=true&offerId=${action.offerId}&contractId=${action.contractId}&propertyId=${action.paymentBreakDowns.propertyId}&activeTab=2`)));
            } else {
                console.warn(`${tag} requestupdateContractPaymentBreakdown invalid response :`, response);
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('project.NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestupdateContractPaymentBreakdown failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateContractPaymentBreakdownFailure(message));
    }
}

export function* requestGetContractReportText(action) {
    const tag = '[REQUEST_GET_CONTRACT_REPORT_TEXT]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.GetContractReportText, jwtToken, action.textId, action.editorKey);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetContractReportText response :`, response.data);
                yield put(Actions.getContractReportTextSuccess(response.data.result));
            } else {
                console.warn(`${tag} requestGetContractReportText invalid response :`, response);
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('project.NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetContractReportText failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getContractReportTextFailure(message));
    }
}

export function* requestUpdateContractText(action) {
    const tag = '[REQUEST_UPDATE_CONTRACT_TEXT]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.UpdateContractText, jwtToken, action.contractText);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateContractText response :`, response.data);
                yield put(Actions.updateContractTextSuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/contract/?iframe=true&offerId=${action.offerId}&contractId=${action.contractId}&propertyId=${action.contractText.propertyId}&activeTab=3`)));
            } else {
                console.warn(`${tag} requestUpdateContractText invalid response :`, response);
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('project.NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateContractText failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateContractTextFailure(message));
    }
}

export function* requestUpdateContractCommission(action) {
    const tag = '[REQUEST_UPDATE_CONTRACT_COMMISSION]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.UpdateContractCommission, jwtToken, action.contractCommission);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateContractCommission response :`, response.data);
                yield put(Actions.updateContractCommissionSuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/contract/?iframe=true&offerId=${action.offerId}&contractId=${action.contractId}&propertyId=${action.contractCommission.propertyId}&activeTab=4`)));
            } else {
                console.warn(`${tag} requestUpdateContractCommission invalid response :`, response);
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('project.NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateContractCommission failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateContractCommissionFailure(message));
    }
}

export function* requestGetDashboardCommission(action) {
    const tag = '[REQUEST_GET_DASHBOARD_COMMISSION]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.GetDashboardCommission, jwtToken, action.userId, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetDashboardCommission response :`, response.data);
                yield put(Actions.getDashboardCommissionSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetDashboardCommission failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getDashboardCommissionFailure(message));
    }
}

export function* requestRestoreContract(action) {
    const tag = '[REQUEST_RESTORE_CONTRACT]';
    try {
        const jwtToken = yield getJwtToken();
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestRestoreContract, jwtToken, action.historyId, action.offerId, action.contractId, action.action);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRestoreContract response :`, response.data);
                yield put(Actions.restoreContractSuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/contract/?iframe=true&offerId=${action.offerId}&contractId=${action.contractId}&activeTab=5`)));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('project.NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRestoreContract failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.restoreContractFailure(message));
    }
}

export function* requestGetEmployeeCommission(action) {
    const tag = '[REQUEST_GET_EMPLOYEE_COMMISSION]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            const response = yield call(API.requestGetEmployeeCommission, jwtToken, branchId, culture, action.employeeCommission);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGetEmployeeCommission response :`, response.data);
                yield put(Actions.getEmployeeCommissionSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('project.NotLoggedIn');
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetEmployeeCommission failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getEmployeeCommissionFailure(message));
    }
}

export function* requestExportAllEmployeeCommission(action) {
    const tag = '[REQUEST_EXPORT_ALL_EMPLOYEE_COMMISSION]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestExportAllEmployeeCommission, jwtToken, branchId, culture, action.allEmployeeCommission);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestExportAllEmployeeCommission response :`, response.data);
                yield put(Actions.exportAllEmployeeCommissionSuccess(response.data.result));
                window.open(response.data.result);
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestExportAllEmployeeCommission failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.exportAllEmployeeCommissionFailure(message));
    }
}


export function* requestGenerateEmpCommission(action) {
    const tag = '[REQUEST_GENERATE_EMP_COMMISSION]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestGenerateEmployeeCommission, jwtToken, branchId, culture, action.empCommissionInput);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGenerateEmpCommission response :`, response.data);
                yield put(Actions.generateEmpCommissionSuccess(response.data.result));
                console.log(`${AppConfig.sagaApiCoreUrl}${response.data.result}`);
                window.open(`${AppConfig.sagaApiCoreUrl}${response.data.result}`);
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGenerateEmpCommission failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generateEmpCommissionFailure(message));
    }
}

export function* requestSearchContact(action) {
    const tag = '[REQUEST_SEARCH_CONTACT]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const searchTerm = action.searchTerm;
        const inputValid = jwtToken && searchTerm && searchTerm.trim().length > 2;
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.requestSearchContact, jwtToken, searchTerm);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestSearchContact response :`, response.data);
                yield put(Actions.searchContactSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestSearchContact failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.searchContactFailure(message));
    }
}
export function* requestGenerateCommissionReport(action) {
    const tag = '[REQUEST_GENERATE_COMMISSION_REPORT]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId && culture) {
            // step 2 : validation passed..
            const response = yield call(API.requestGenerateCommissionReport, jwtToken, branchId, culture, action.contractId, action.saleId, action.exportType, action.commissionId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGenerateCommissionReport response :`, response.data);
                // popup new window for open/download excel, pdf file
                window.open(response.data.result, '_blank');
                yield put(Actions.generateCommissionReporteSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn'); // <-- fix me
        }

    }
    catch (e) {
        console.warn(`${tag} requestGenerateCommissionReport failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generateCommissionReporteFailure(message));
    }
}

export function* requestGenerateContractReport(action) {
    const tag = '[REQUEST_GENERATE_CONTRACT_REPORT]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId && culture) {
            const response = yield call(API.requestGenerateContractReport, jwtToken, branchId, culture, action.propertyId, action.contractId);
            console.log('action => ', action);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestGenerateContractReport response :`, response.data);
                const url = getSagaWAPUrl('viewReport', null, null, branchId, { reportName: 'contractReport', resultURL: response.data.result });
                window.open(url, '_blank');
                yield put(Actions.generateContractReportSuccess(true));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGenerateContractReport failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generateContractReportFailure(message));
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(SagaContractTypes.REQUEST_CONTRACT_DETAIL, requestContractDetail),
        takeLatest(SagaContractTypes.REQUEST_UPDATE_CONTRACT_DETAIL, requestUpdateContractDetail),
        takeLatest(SagaContractTypes.REQUESTUPDATE_CONTRACT_PAYMENT_BREAKDOWN, requestupdateContractPaymentBreakdown),
        takeLatest(SagaContractTypes.REQUEST_GET_CONTRACT_REPORT_TEXT, requestGetContractReportText),
        takeLatest(SagaContractTypes.REQUEST_UPDATE_CONTRACT_TEXT, requestUpdateContractText),
        takeLatest(SagaContractTypes.REQUEST_UPDATE_CONTRACT_COMMISSION, requestUpdateContractCommission),
        takeLatest(SagaContractTypes.REQUEST_GET_DASHBOARD_COMMISSION, requestGetDashboardCommission),
        takeLatest(SagaContractTypes.REQUEST_RESTORE_CONTRACT, requestRestoreContract),
        takeLatest(SagaContractTypes.REQUEST_GET_EMPLOYEE_COMMISSION, requestGetEmployeeCommission),
        takeLatest(SagaContractTypes.REQUEST_EXPORT_ALL_EMPLOYEE_COMMISSION, requestExportAllEmployeeCommission),
        takeLatest(SagaContractTypes.REQUEST_GENERATE_EMP_COMMISSION, requestGenerateEmpCommission),
        takeLatest(SagaContractTypes.REQUEST_SEARCH_CONTACT, requestSearchContact),
        takeLatest(SagaContractTypes.REQUEST_GENERATE_COMMISSION_REPORT, requestGenerateCommissionReport),
        takeLatest(SagaContractTypes.REQUEST_GENERATE_CONTRACT_REPORT, requestGenerateContractReport),
    ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagaContract/sagaContractSaga.ts